<template>
    <div class="ca-custom-select">
        <div class="ca-custom-select__header"
             @click.prevent="toggleDropdown()"
            v-bind:class="{ 'text-left' : !displayDefaultText }">
            <span v-if="displayDefaultText">{{ heading }}</span>

            <span v-else>
                {{ selected_option.text }}
            </span>

            <a href="#" class="ca-custom-select__toggle">
                <span v-if="!is_dropdown" class="inline-fa">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"/></svg>
                </span>

                <span v-if="is_dropdown" class="inline-fa">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"/></svg>
                </span>
            </a>
        </div>

        <div class="ca-custom-select__options"
            v-bind:class="{ 'active' : is_dropdown }">
            <a href="#" class="ca-custom-select__option" v-for="(option, index) in options" :key="index"
                @click.prevent="selectOption(option)"
                v-bind:class="{ 'selected' : isSelectedOption(option) }">
                {{ option.text }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        heading: {},
        options: {
            default: () => [
                // {
                //     value: 1,
                //     text: ''
                // }
            ]
        },
        defaultvalue: {
            default: () => 0
        }
    },

    data() {
        return {
            selected_option: {
                value: "",
                text: this.heading
            },
            is_dropdown: false
        }
    },

    computed: {
        displayDefaultText() {
            return this.is_dropdown || this.selected_option.value === ''
        }
    },

    methods: {
        toggleDropdown() {
            this.is_dropdown = !this.is_dropdown;


        },

        selectOption(option) {
            this.selected_option = option;
            this.is_dropdown = false;
            this.$emit('option-selected', option);
        },

        isSelectedOption(option) {
           return option.value == this.selected_option.value;
        },

        sync() {
            this.selected_option.value = this.defaultvalue;

            for (var i = 0; i < this.options.length; i++) {
                var option = this.options[i];

                if (option.value == this.selected_option.value) {
                    this.selected_option.text = option.text;
                    break;
                }
            }
        }
    },

    created() {
        this.sync();
    },

    mounted() {
        this.sync();
    },

    watch: {
        selected_option: () => {
            // selected_option is a prop, but sometimes, in the parent, the selected option is loaded along with all the other data
            // via ajax, so on load we won't have a value for it. So we watch for a change, and when it's set we display the
            // relevant info
            this.sync();
        }
    }
}
</script>

<style lang="scss">
    .ca-custom-select {
        text-align: center;
        cursor: pointer;
        border: 1px solid $color-white;
        padding: 0.375rem 0.75rem;
        border-radius: 30px;
        margin: 1rem 0;

        &__header {
            position: relative;
        }

        &__toggle {
            position: absolute;
            right: 0;
            color: $color-white;
            transition: 0.2s ease-in;
        }

        &:hover &__toggle {
            color: $color-gold;
        }

        &__inner {

        }

        &__options {
            //background-color: $color-dark-blue;
            visibility: hidden;
            overflow: hidden;
            max-height: 0;
            transition: all 0.2s ease-in-out;

            &.active {
                visibility: visible;
                border-top: 1px solid $color-white;
                margin-top: 0.5rem;
                padding-top: 0.5rem;
                max-height: fit-content;
                overflow: auto;
            }
        }

        &__option {
            padding: 0.1rem;
            display: block;
            color: $color-white;

            &:hover {
                color: $color-gold;
            }

            &.selected {
                color: $color-gold;
            }
        }
    }
</style>